var React = require('react');

function IconHamburgerCloseInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"a","d":"M23.314 1.186a1.5 1.5 0 0 1 0 2.122L14.12 12.5l9.193 9.192a1.5 1.5 0 0 1-2.122 2.122L12 14.62l-9.192 9.193a1.5 1.5 0 0 1-2.122-2.122L9.88 12.5.686 3.308a1.5 1.5 0 1 1 2.122-2.122L12 10.38l9.192-9.193a1.5 1.5 0 0 1 2.122 0z"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","transform":"translate(4 -1)","key":1},[React.createElement("mask",{"id":"b","fill":"#fff","key":0},React.createElement("use",{"xlinkHref":"#a"})),React.createElement("use",{"fill":"#74B443","xlinkHref":"#a","key":1}),React.createElement("path",{"fill":"#FFF","d":"M-6-1h36v30H-6z","mask":"url(#b)","key":2})])]);
}

IconHamburgerCloseInline.defaultProps = {"width":"32","height":"23","viewBox":"0 0 32 23"};

module.exports = IconHamburgerCloseInline;

IconHamburgerCloseInline.default = IconHamburgerCloseInline;
